/**
 * Realtime: ticket do WebSocket, resync e os eventos do socket. É o último da
 * cadeia de imports (depende de conversas/mensagens/canais/notificações), então
 * nenhum outro DTO importa daqui — é assim que a pasta fica sem ciclos.
 */
import { z } from "zod";
import { uuid } from "./common.js";
import { channel } from "./channels.js";
import { conversation } from "./conversations.js";
import { message } from "./messages.js";
import { notification } from "./notifications.js";

/* ---------- Realtime ---------- */
export const realtimeTicket = z.object({
  ticket: z.string(),
  url: z.string().optional(),
  expiresAt: z.string().optional(),
});
export type RealtimeTicket = z.infer<typeof realtimeTicket>;

export const realtimeResyncInput = z.object({
  last_seq: z.string().optional(),
  since: z.string().optional(),
});

/* ---------- WebSocket ---------- */
export const wsClientEvent = z.discriminatedUnion("type", [
  z.object({ type: z.literal("subscribe"), channels: z.array(uuid) }),
  z.object({ type: z.literal("typing"), conversationId: uuid }),
  z.object({ type: z.literal("ping") }),
]);

export const wsServerEvent = z.discriminatedUnion("type", [
  z.object({ type: z.literal("message.created"), conversationId: uuid, message }),
  z.object({ type: z.literal("message.updated"), conversationId: uuid, message }),
  z.object({ type: z.literal("conversation.updated"), conversation }),
  z.object({ type: z.literal("notification.created"), notification }),
  z.object({ type: z.literal("channel.updated"), channel }),
  z.object({ type: z.literal("pong") }),
]);
export type WsServerEvent = z.infer<typeof wsServerEvent>;
